module.exports = __webpack_public_path__ + "assets/5e18ddb845ca6fdb0d5fc323166048dc.mp3";